// admin - employee
// PT = performance tracker
export const HIT_PT_LIST_EMPLOYEE = 'HIT_PT_LIST_EMPLOYEE';
export const GET_PT_LIST_EMPLOYEE = 'GET_PT_LIST_EMPLOYEE';

export const HIT_PT_LIST_BOARD = 'HIT_PT_LIST_BOARD';
export const GET_PT_LIST_BOARD = 'GET_PT_LIST_BOARD';

export const HIT_PT_LIST_EMPLOYEE_MANAGEMENT = 'HIT_PT_LIST_EMPLOYEE_MANAGEMENT';
export const GET_PT_LIST_EMPLOYEE_MANAGMENT = 'GET_PT_LIST_EMPLOYEE_MANAGMENT';

export const HIT_PT_ADD_EMPLOYEE = 'HIT_PT_ADD_EMPLOYEE';

export const HIT_PT_LIST_STRUCTURE = 'HIT_PT_LIST_STRUCTURE';
export const GET_PT_LIST_STRUCTURE = 'GET_PT_LIST_STRUCTURE';

export const HIT_PT_LIST_JOB_LEVEL = 'HIT_PT_LIST_JOB_LEVEL';
export const GET_PT_LIST_JOB_LEVEL = 'GET_PT_LIST_JOB_LEVEL';

// admin - employee
